import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import type { WorkingHoursV3CalendarEvent } from '../../../types';

interface Props {
  event: WorkingHoursV3CalendarEvent;
}
export const WorkingHoursV3 = ({ event }: Props) => {
  return (
    <div data-event-type={event.eventType} css={containerStyle}>
      Working:{event.startTime}-{event.duration}
    </div>
  );
};

const containerStyle = css({
  padding: theme.spacing(0.5),
  background: theme.colors.white,
  border: `2px solid black`,
  borderRadius: theme.borderRadius.medium,
});
